(() => {
  if (window.SharedSweeps) {
    window.SharedSweeps.refresh?.();
    return;
  }

  const SharedSweeps = {};
  window.SharedSweeps = SharedSweeps;

  const CARD_SELECTORS = '[data-product-card], .product-card, .grid-view-item, .card-wrapper, .product-grid-item, .price_title';
  const CARD_PRICE_SELECTORS = '.price-amount.amount .money[data-product-id], .price-amount.amount .money, .price-item--regular .money, .price__regular .money, .price .money:not(.compare), .money';
  const PDP_PRICE_SELECTORS = '.price .price-item--regular .money, .price__regular .money, .price .money:not(.compare), .price-item--regular.money, .price__current .money, .money';
  const PDP_QTY_SELECTORS = 'input[name="quantity"], .quantity__input';
  const CART_QTY_SELECTORS = '.quantity__input, .qty, input[name^="updates"], select[data-cartitem-quantity]';

  let settingsInit = false;
  let cartEntriesInit = false;
  let cardInit = false;
  let pdpInit = false;
  let cartBadgesInit = false;

  const safeParsePrice = (text) => {
    if (!text) return 0;
    let t = String(text).replace(/[^0-9,.\-]/g, '').trim();
    if (t.includes(',') && t.includes('.')) {
      const lc = t.lastIndexOf(',');
      const ld = t.lastIndexOf('.');
      t = lc > ld ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '');
    } else if (t.includes(',')) {
      t = t.replace(',', '.');
    }
    const n = parseFloat(t);
    return Number.isNaN(n) ? 0 : n;
  };

  const parseMoneyToNumber = (text) => {
    if (!text) return NaN;
    const cleaned = String(text).replace(/[^0-9,.\-]/g, '').replace(/\.(?=.*\.)/g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    return Number.isNaN(num) ? NaN : num;
  };

  const findBestMoneyValue = (root) => {
    if (!root) return NaN;

    const saleMoney = root.querySelector('ins .money, .price__sale .money, .price-item--sale .money');
    if (saleMoney) return parseMoneyToNumber(saleMoney.textContent || saleMoney.innerText);

    const moneyNodes = Array.from(root.querySelectorAll('.money'));
    if (moneyNodes.length) {
      const nonCompare = moneyNodes.find((el) => !el.closest('del') && !el.closest('.price__compare'));
      const target = nonCompare || moneyNodes[0];
      return parseMoneyToNumber(target.textContent || target.innerText);
    }

    return NaN;
  };

  const initSharedSweepsSettings = () => {
    if (settingsInit) return;
    settingsInit = true;

    const config = window.SharedSweepsConfig || {};
    const token = config.token;
    const shopDomain = config.shopDomain;
    if (!token || !shopDomain || !window.fetch) return;

    const storageKey = `sharedsweeps:settings:${shopDomain}`;
    const cached = sessionStorage.getItem(storageKey);
    if (cached) {
      try {
        window.SharedSweepsSettings = JSON.parse(cached);
        return;
      } catch (error) {
        sessionStorage.removeItem(storageKey);
      }
    }

    fetch('https://external-api-prod.sharedsweepsapp.com/products/settings/', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Shopify-Shop-Domain': shopDomain
      },
      credentials: 'omit'
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Sharedsweeps settings request failed: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        window.SharedSweepsSettings = data;
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(data));
        } catch (error) {
        }
      })
      .catch(() => {
      });
  };

  const initSharedSweepsCartEntries = () => {
    if (cartEntriesInit) return;
    cartEntriesInit = true;

    const getCartTotal = () => {
      const totalEl = document.querySelector(
        '#cart-drawer-footer-total, #ajax-total, .drawer__footer .totals .totals__total-value, .totals .totals__total-value, .cart__footer .totals__total-value'
      );
      const totalValue = safeParsePrice(totalEl?.textContent || '');
      if (totalValue > 0) return totalValue;

      const checkoutButton = document.querySelector('.cart-drawer-footer .checkout-button, .checkout-button');
      const checkoutValue = safeParsePrice(checkoutButton?.textContent || '');
      if (checkoutValue > 0) return checkoutValue;

      const sawEl = document.querySelector('.drawer__footer .saw-cart-total, .saw-cart-total');
      return safeParsePrice(sawEl?.textContent || '');
    };

    const getBonusEntries = (cartTotal) => {
      const thresholds = window.SharedSweepsSettings?.activeBonusEntryThresholds;
      if (!Array.isArray(thresholds) || cartTotal <= 0) return 0;

      const now = Date.now();
      return thresholds.reduce((sum, entry) => {
        const subtotal = Number(entry?.subtotal);
        const bonus = Number(entry?.bonusEntries);
        if (!Number.isFinite(subtotal) || !Number.isFinite(bonus)) return sum;
        if (cartTotal < subtotal) return sum;

        const start = entry?.startDate ? Date.parse(entry.startDate) : null;
        const end = entry?.endDate ? Date.parse(entry.endDate) : null;
        if ((start && now < start) || (end && now > end)) return sum;

        return sum + bonus;
      }, 0);
    };

    const getBaseEntries = (el) => {
      if (!el) return 0;
      const cached = parseInt(el.dataset.ssBaseEntries, 10);
      if (!Number.isNaN(cached)) return cached;
      const parsed = parseInt(String(el.textContent || '').replace(/[^\d]/g, ''), 10);
      const base = Number.isNaN(parsed) ? 0 : parsed;
      el.dataset.ssBaseEntries = String(base);
      return base;
    };

    const applyBonusEntries = () => {
      const cartTotal = getCartTotal();
      const bonusEntries = getBonusEntries(cartTotal);
      const targets = document.querySelectorAll(
        '.sharedsweeps-cart-total-wrapper .ss-rg-value.ss-ce-value, .ss-ce-total .ss-rg-value.ss-ce-value'
      );
      if (!targets.length) return;

      targets.forEach((target) => {
        const baseEntries = getBaseEntries(target);
        const nextValue = baseEntries + bonusEntries;
        const nextText = String(nextValue);
        if (target.textContent !== nextText) target.textContent = nextText;
      });
    };

    const updateAjaxEntries = () => {
      const cartContainers = document.querySelectorAll('#Cart-Drawer, .cart-drawer, .cart__drawer, form[action*="/cart"]');
      if (!cartContainers.length) {
        applyBonusEntries();
        return;
      }

      cartContainers.forEach((container) => {
        const values = container.querySelectorAll('.ss-cart-value');
        if (!values.length) return;

        let total = 0;
        values.forEach((el) => {
          total += safeParsePrice(el.textContent);
        });

        const target = container.querySelector('.ss-ce-total .ss-rg-value.ss-ce-value');
        if (target) {
          // Keep base entries in data attribute and let applyBonusEntries do the single text write.
          const nextBase = String(Math.floor(total));
          if (target.dataset.ssBaseEntries !== nextBase) {
            target.dataset.ssBaseEntries = nextBase;
          }
        }
      });

      applyBonusEntries();
    };

    let drawerObserver = null;
    let bodyObserver = null;
    let lastDrawer = null;
    let rafPending = false;

    const scheduleUpdate = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        updateAjaxEntries();
      });
    };

    const attachDrawerObserver = (drawer) => {
      if (!drawer || !('MutationObserver' in window)) return;
      if (drawerObserver) drawerObserver.disconnect();

      drawerObserver = new MutationObserver(() => {
        scheduleUpdate();
      });
      drawerObserver.observe(drawer, { childList: true, subtree: true });
    };

    const ensureDrawerObserver = () => {
      const drawer = document.getElementById('Cart-Drawer') || document.getElementById('cart-drawer');
      if (!drawer) return;
      if (drawer !== lastDrawer) {
        lastDrawer = drawer;
        attachDrawerObserver(drawer);
      }
      scheduleUpdate();
    };

    const attachBodyObserver = () => {
      if (bodyObserver || !('MutationObserver' in window)) return;
      bodyObserver = new MutationObserver((mutations) => {
        const hasDrawerMutation = mutations.some((mutation) => {
          const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
          return nodes.some((node) => {
            if (node.nodeType !== 1) return false;
            if (node.id === 'Cart-Drawer' || node.id === 'cart-drawer') return true;
            return typeof node.querySelector === 'function' && node.querySelector('#Cart-Drawer, #cart-drawer');
          });
        });

        if (hasDrawerMutation) ensureDrawerObserver();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    };

    const init = () => {
      ensureDrawerObserver();
      attachBodyObserver();
      document.addEventListener('cart:updated', scheduleUpdate);
      document.addEventListener('cart:refresh', scheduleUpdate);
      document.addEventListener('line-item:change:end', scheduleUpdate);
      document.addEventListener('cart:item-added', scheduleUpdate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  };

  const initProductCardBadges = () => {
    if (cardInit) return;
    cardInit = true;

    const findCard = (el) => {
      return el.closest('.product-card, product-card, .sharedsweeps-product-card-wrapper') || null;
    };

    const findDisplayedPriceFor = (productId, badgeEl) => {
      const wrapper = findCard(badgeEl);
      if (!wrapper) return NaN;
      const card = wrapper.matches('.product-card, product-card') ? wrapper : wrapper.closest('.product-card, product-card');
      if (!card) return NaN;
      const money = card.querySelector(`.price-amount.amount .money[data-product-id="${productId}"]`);
      if (money) return parseMoneyToNumber(money.textContent || money.innerText);
      const priceRoot = card.querySelector('.price') || card;
      return findBestMoneyValue(priceRoot);
    };

    const computeEntries = (price, mult, bonus) => {
      const base = Math.floor((price || 0) * (mult || 1));
      return base + (parseInt(bonus, 10) || 0);
    };

    const updateBadge = (badge) => {
      const pid = badge.getAttribute('data-product-id');
      const meta = parseFloat(badge.getAttribute('data-meta-price')) || 0;
      const mult = parseFloat(badge.getAttribute('data-mult')) || 1;
      const bonus = parseFloat(badge.getAttribute('data-bonus')) || 0;
      const displayed = findDisplayedPriceFor(pid, badge);
      const price = Number.isNaN(displayed) ? meta : displayed;
      const entries = computeEntries(price, mult, bonus);
      const valueEl = badge.querySelector('[data-ss-value]');
      if (valueEl) valueEl.textContent = entries;
    };

    const observedCards = new WeakMap();

    const ensureObserver = (badge) => {
      const wrapper = findCard(badge);
      if (!wrapper) return;
      const card = wrapper.matches('.product-card, product-card') ? wrapper : wrapper.closest('.product-card, product-card');
      if (!card || observedCards.has(card)) return;
      let ticking = false;
      const observer = new MutationObserver(() => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          card.querySelectorAll('[data-ss]').forEach(updateBadge);
          ticking = false;
        });
      });
      observer.observe(card, { subtree: true, childList: true, characterData: true });
      observedCards.set(card, observer);
    };

    const initAll = () => {
      document.querySelectorAll('[data-ss]').forEach((b) => {
        updateBadge(b);
        ensureObserver(b);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  };

  const initPdpBadges = () => {
    if (pdpInit) return;
    pdpInit = true;

    const closestForm = (node) => node.closest?.('[data-product-form], form[action*="/cart/add"], product-form, .thb-product-detail, [data-productid]') || document;

    const findScopedPriceRoot = (badge) => {
      const root = closestForm(badge);
      const badgeProductId = badge.getAttribute('data-product-id');
      if (badgeProductId && root) {
        const scoped = root.querySelector(`[data-productid="${badgeProductId}"]`) || root;
        return scoped.querySelector('.product-price-container .price') || scoped.querySelector('.price') || scoped;
      }
      return root.querySelector?.('.product-price-container .price') || root.querySelector?.('.price') || root;
    };

    const readDisplayedPrice = (badge) => {
      const priceRoot = findScopedPriceRoot(badge);
      const moneyValue = findBestMoneyValue(priceRoot);
      if (!Number.isNaN(moneyValue)) return moneyValue;
      const fallback = priceRoot?.querySelector?.(PDP_PRICE_SELECTORS);
      return fallback ? parseMoneyToNumber(fallback.textContent || fallback.innerText) : NaN;
    };

    const readQty = (root) => {
      const q = root.querySelector(PDP_QTY_SELECTORS);
      const v = q ? parseInt(q.value, 10) : 1;
      return Number.isNaN(v) || v < 1 ? 1 : v;
    };

    const computeEntries = (price, mult, bonus, qty) => {
      const base = Math.floor((price || 0) * (mult || 1) * (qty || 1));
      const extra = (parseInt(bonus, 10) || 0) * (qty || 1);
      return { entries: base, bonus: extra };
    };

    const updateBadge = (badge) => {
      const form = closestForm(badge);
      const displayed = readDisplayedPrice(badge);
      const meta = parseFloat(badge.getAttribute('data-meta')) || 0;
      const mult = parseFloat(badge.getAttribute('data-mult')) || 1;
      const bonus = parseFloat(badge.getAttribute('data-bonus')) || 0;
      const qty = readQty(form);
      const price = Number.isNaN(displayed) ? meta : displayed;
      const res = computeEntries(price, mult, bonus, qty);
      const vEl = badge.querySelector('.ss-pdp-value:not(.entries-subscription)');
      const bEl = badge.querySelector('.ss-pdp-bonus');
      if (vEl && vEl.textContent !== String(res.entries)) vEl.textContent = String(res.entries);
      if (bEl && bEl.textContent !== String(res.bonus)) bEl.textContent = String(res.bonus);
    };

    const observed = new WeakMap();

    const ensureObservers = (badge) => {
      const root = closestForm(badge);
      if (!root || observed.has(root)) return;
      let ticking = false;
      const mo = new MutationObserver(() => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          root.querySelectorAll('.ss-pdp-badge').forEach(updateBadge);
          ticking = false;
        });
      });
      mo.observe(root, { subtree: true, childList: true, characterData: true });
      observed.set(root, mo);
    };

    const attachInputs = (badge) => {
      const root = closestForm(badge);
      if (!root || root.dataset.ssPdpInputs === 'true') return;
      root.dataset.ssPdpInputs = 'true';
      root.addEventListener(
        'input',
        (e) => {
          if (e.target && e.target.matches(PDP_QTY_SELECTORS)) {
            requestAnimationFrame(() => {
              root.querySelectorAll('.ss-pdp-badge').forEach(updateBadge);
            });
          }
        },
        { passive: true }
      );
      root.addEventListener(
        'change',
        (e) => {
          if (e.target && e.target.matches('select, input[type="radio"]')) {
            requestAnimationFrame(() => {
              root.querySelectorAll('.ss-pdp-badge').forEach(updateBadge);
            });
          }
        },
        { passive: true }
      );
      document.addEventListener('variant:changed', () => {
        requestAnimationFrame(() => {
          root.querySelectorAll('.ss-pdp-badge').forEach(updateBadge);
        });
      });
      document.addEventListener('product:variant-change', () => {
        requestAnimationFrame(() => {
          root.querySelectorAll('.ss-pdp-badge').forEach(updateBadge);
        });
      });
    };

    const initAll = () => {
      document.querySelectorAll('.ss-pdp-badge').forEach((b) => {
        updateBadge(b);
        ensureObservers(b);
        attachInputs(b);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        requestAnimationFrame(initAll);
      }, { once: true });
    } else {
      requestAnimationFrame(initAll);
    }
  };

  const initCartItemBadges = () => {
    if (cartBadgesInit) return;
    cartBadgesInit = true;

    const parseQty = (el) => {
      const v = parseInt(el && el.value, 10);
      return Number.isNaN(v) || v < 1 ? 1 : v;
    };

    const readLineTotalFromRow = (badge) => {
      const row = badge.closest('tr') || badge.closest('[data-cart-item], .cart-item, li, .cart__item, .product-cart-item');
      if (!row) return 0;
      const cell = row.querySelector(
        '.cart-item__totals .price--end, .cart-item__totals .cart-item__final-price, .cart-item__totals .price, td.text-end, .line-item__price, [data-cart-item-line-price], .product-cart-item-price .amount, .pn-total-line-item'
      );
      if (cell) return safeParsePrice(cell.textContent);
      return 0;
    };

    const findQtyElNearby = (badge) => {
      const row = badge.closest('[data-cart-item], .cart-item, li, .cart__item, .product-cart-item');
      return row ? row.querySelector(CART_QTY_SELECTORS) : null;
    };

    const updateBadge = (badge) => {
      const mult = parseFloat(badge.dataset.mult) || 1;
      const bonus = parseFloat(badge.dataset.bonus) || 0;
      const qtyEl = findQtyElNearby(badge);
      const qty = qtyEl ? parseQty(qtyEl) : Number(badge.dataset.qty);

      let lineTotal = readLineTotalFromRow(badge);
      if (!lineTotal) {
        const unit = parseFloat(badge.dataset.unit) || parseFloat(badge.dataset.base) || 0;
        lineTotal = unit * qty;
      }
      const entries = Math.floor(lineTotal * mult);
      const valEl = badge.querySelector('.ss-cart-value');
      const bonusEl = badge.querySelector('.ss-cart-bonus');
      if (valEl && valEl.textContent !== String(entries)) valEl.textContent = String(entries);
      if (bonusEl && bonusEl.textContent !== String(bonus * qty)) bonusEl.textContent = String(bonus * qty);
    };

    let isUpdating = false;
    const updateAll = (scope) => {
      if (isUpdating) return;
      isUpdating = true;
      try {
        const root = scope || document;
        root.querySelectorAll('.ss-cart-badge').forEach(updateBadge);
      } finally {
        isUpdating = false;
      }
    };

    const attachListeners = (scope) => {
      const root = scope || document;
      root.addEventListener(
        'input',
        (e) => {
          if (e.target && e.target.matches(CART_QTY_SELECTORS)) {
            const row = e.target.closest('[data-cart-item], .cart-item, li, .cart__item, .product-cart-item');
            if (row) {
              row.querySelectorAll('.ss-cart-badge').forEach(updateBadge);
            } else {
              updateAll();
            }
          }
        },
        { passive: true }
      );
      root.addEventListener(
        'change',
        (e) => {
          if (e.target && e.target.matches('select[data-cartitem-quantity], input[name^="updates"]')) updateAll();
        },
        { passive: true }
      );
    };

    const initAll = () => {
      updateAll();
      attachListeners();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        requestAnimationFrame(initAll);
      }, { once: true });
    } else {
      requestAnimationFrame(initAll);
    }

    const container = document.querySelector('#Cart-Drawer, .cart-drawer, .cart__drawer, form[action*="/cart"]');
    if (container && 'MutationObserver' in window) {
      let raf = false;
      const mo = new MutationObserver(() => {
        if (isUpdating) return;
        if (raf) return;
        raf = true;
        requestAnimationFrame(() => {
          raf = false;
          updateAll(container);
        });
      });
      mo.observe(container, { childList: true, subtree: true });
    }

    window.addEventListener('cart:updated', () => {
      requestAnimationFrame(() => {
        updateAll();
      });
    });
    window.addEventListener('cart:refresh', () => {
      requestAnimationFrame(() => {
        updateAll();
      });
    });
  };

  SharedSweeps.init = () => {
    initSharedSweepsSettings();
    initSharedSweepsCartEntries();
    initProductCardBadges();
    initPdpBadges();
    initCartItemBadges();
  };

  SharedSweeps.refresh = () => {
    initSharedSweepsCartEntries();
    initProductCardBadges();
    initPdpBadges();
    initCartItemBadges();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => SharedSweeps.init(), { once: true });
  } else {
    SharedSweeps.init();
  }
})();
